/*
 *
 * DocumentsStatementsCustomDownloadModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 09-Apr-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DocumentsStatementsCustomDownloadModal from './DocumentsStatementsCustomDownloadModal'
import * as DocumentsActions from '../../routes/Documents/modules/DocumentsActions'
import * as HomePageActions from '../../routes/Homepage/modules/HomepageActions'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(DocumentsActions, dispatch),
  ...bindActionCreators(HomePageActions, dispatch)
})

const mapStateToProps = state => ({
  title: nullSafe(() => state.popup.popupInfo.title, ''),
  description: nullSafe(() => state.popup.popupInfo.description, ''),
  children: nullSafe(() => state.popup.popupInfo.children, null),
  onClose: nullSafe(() => state.popup.popupInfo.onClose, () => { }),
  primaryButtonLabel: nullSafe(() => state.popup.popupInfo.primaryButtonLabel, ''),
  secondaryButtonLabel: nullSafe(() => state.popup.popupInfo.secondaryButtonLabel, ''),
  downloadType: nullSafe(() => state.popup.popupInfo.downloadType, ''),
  requestParams: nullSafe(() => state.popup.popupInfo.requestParams, ''),
  setDownloadIdFromModal: nullSafe(() => state.popup.popupInfo.setDownloadIdFromModal, () => { }),
  downloadLoading: nullSafe(() => state.loading.localLoading.get_download, false),
  fromHome: nullSafe(() => state.popup.popupInfo.fromHome, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(DocumentsStatementsCustomDownloadModal)
